import { render, staticRenderFns } from "./GetDispatchReportData.vue?vue&type=template&id=4bc9f40c&scoped=true&"
import script from "./GetDispatchReportData.vue?vue&type=script&lang=js&"
export * from "./GetDispatchReportData.vue?vue&type=script&lang=js&"
import style0 from "./GetDispatchReportData.vue?vue&type=style&index=0&id=4bc9f40c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc9f40c",
  null
  
)

export default component.exports